export const viewNamePrefix = 'Insertion';
